var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-ellipse-progress',{staticClass:"mt-5",attrs:{"reverse":"","thickness":15,"emptyThickness":"10%","legend":false,"data":_vm.graphData,"gap":7,"loading":_vm.loading}})}
var staticRenderFns = []

export { render, staticRenderFns }